export enum PaymentType {
  CASH = 'cash',
  CASH_AND_POINTS = 'cash and points',
  POINTS = 'points',
}
